import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SourceConstants from 'constants/SourceConstants';
import CreateSourceModal from 'create-components/CreateSourceModal';
import * as tour from 'help/Tour';
import {TourViewOptions} from 'help/Tour';
import NavStore from 'nav/NavStore';
import {NavTutorialForNewUsers} from 'nav/NavTutorial';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';
import legacyRunModal from 'ui-library/legacyRunModal';

const {PROJECT_TYPE} = SourceConstants;

// Track last opened ELN tutorial `TourView`
let tourView: tour.TourView | null = null;

export function runTutorial(): void {
  analytics.track('onboarding_tour', 'started', {
    tour: 'navigation',
    tourOrigin: 'checklist_sidepanel',
    numberOfSteps: 6,
    eventLastModified: 'FY21_Q1a2',
  });
  if (tourView != null) {
    // Kill existing (last opened) tour if it exists, before creating a new one
    tourView.kill(false);
  }
  const currentUser = EntityStore.currentUser();
  if (currentUser == null) {
    return;
  }
  const project = _.findWhere(NavStore.getSources()!, {sourceType: PROJECT_TYPE});
  if (project != null) {
    const tutorial = NavTutorialForNewUsers;
    const tourViewOptions: TourViewOptions = {
      collection: new tour.Tour(tutorial),
      onFinish() {
        analytics.track('onboarding_tour', 'completed', {
          tour: 'navigation',
          tourOrigin: 'checklist_sidepanel',
          numberOfSteps: 6,
          eventLastModified: 'FY21_Q1a2',
        });
        OnboardingActions.completeOnboardingTask(
          OnboardingConstants.MODULES.GETTING_STARTED,
          OnboardingConstants.MAIN_TOUR
        );
      },
    };
    tourView = new tour.TourView(tourViewOptions);
    tourView.next();
  } else {
    notifications.warn('Create a project and then reopen the tutorial.');
    legacyRunModal(CreateSourceModal, {});
  }
}
